import React, { useEffect, useState } from "react";
import { getMedia } from "../Service/Api";
import { Link } from 'react-router-dom' 
import LazyLoad from 'react-lazyload';
const ClassPhotographs = () => {
    const [data, setData] = useState([]);
    const [filterData, setFilteredData] = useState([]);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
    const [yearRanges, setYearRanges] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
  
    useEffect(() => {
      const fetchData = async () => {
        const galleryData1 = await getMedia(); // Your API call
  
        // Sorting logic unchanged
        const romanToInt = (roman) => {
          const map = {
            I: 1, II: 2, III: 3, IV: 4, V: 5,
            VI: 6, VII: 7, VIII: 8, IX: 9,
            X: 10, XI: 11, XII: 12
          };
          return map[roman.toUpperCase()] ?? Infinity;
        };
  
        const normalize = (title) => {
            const raw = title.toUpperCase().trim();
            const clean = raw.replace(/[-–—]/g, ' ');
          
            // Match PREP, then Roman numerals from longest to shortest (to avoid premature matching)
            const rx = /^(PREP|XII|XI|X|IX|VIII|VII|VI|V|IV|III|II|I)\s*([A-Z])\b/;
            const match = clean.match(rx);
          
            if (!match) return [Infinity, 'Z', null];
            const gradeStr = match[1];
            const section = match[2];
            
            const romanToInt = (roman) => {
              const map = {
                PREP: 0, I: 1, II: 2, III: 3, IV: 4, V: 5,
                VI: 6, VII: 7, VIII: 8, IX: 9, X: 10,
                XI: 11, XII: 12
              };
              return map[roman.toUpperCase()] ?? Infinity;
            };
          
            const grade = romanToInt(gradeStr);
            return [grade, section, raw];
          };
  
        const galleryData = galleryData1.sort((a, b) => {
          const [gA, sA] = normalize(a.title);
          const [gB, sB] = normalize(b.title);
          if (gA !== gB) return gA - gB;
          return sA.localeCompare(sB);
        });
  
        setData(galleryData);
  
        // Populate yearRanges dynamically based on dates in data
        const yearsSet = new Set();
        galleryData.forEach(item => {
          if (item.date) {
            yearsSet.add(new Date(item.date).getFullYear());
          }
        });
        setYearRanges([...yearsSet].sort((a, b) => b - a)); // descending order
      };
  
      fetchData();
    }, []);
  
    useEffect(() => {
      let filteredData = data;
      if (selectedYear !== "All") {
        filteredData = filteredData.filter(item => {
          if (item.date) {
            return new Date(item.date).getFullYear() === parseInt(selectedYear);
          }
          return false;
        });
      }
      if (searchQuery) {
        filteredData = filteredData.filter(item =>
          item.title.toLowerCase().includes(searchQuery.toLowerCase())
        );
      }
      setFilteredData(filteredData);
    }, [selectedYear, searchQuery, data]);
  return (
    <>
    <section className="page-header">
        <div className="page-header-bg"></div>
        <div className="page-header-shape-1"><LazyLoad><img src="https://webapi.entab.info/api/image/LCSD/public/Images/page-header-shape-1.png" alt="Loreto Convent School, Delhi Cantt"/></LazyLoad></div>
        <div className="container">
        <div className="page-header__inner">
            <ul className="thm-breadcrumb list-unstyled ml-0">
                <li><Link to="/"> Home</Link></li>
                <li> Gallery </li>
                <li> Class Photographs  </li>
            </ul>
            <h2>Class Photographs </h2>
        </div>
        </div>
    </section>
    <section className="innerbody">
   <div className="container">
  
         <div className="row tabs-dynamic">
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
               <div className="count-val">
                  <p>Total Categories:  </p>
               </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
               <div className="month-selection">
                   
               <select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
               {yearRanges.map(year => (
                 <option key={year} value={year}>{year}</option>
               ))}
             </select>
               </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
               <div className="searchBox">
               <input
                    type="text"
                    id="myInput"
                    name="name"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search Here.."
                />
               </div>
            </div>
         </div>
         <div className="row years year2023 showYear">

            
         {filterData.length > 0 && filterData.map((item, index) => (
             <div key={index} className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-12 galleryCount">
               <div className="gal_new">
                  <article>
                     <div><LazyLoad>
                     <a data-magnify="gallery" data-src="" data-group="a" href={`https://webapi.entab.info/api/image/${item?.attachments}`}>
                        <img src={`https://webapi.entab.info/api/image/${item?.attachments}`} alt="Loreto Convent School Delhi Cantt" className="img-fluid"/>
                      </a>   
                       </LazyLoad>
                     </div>
                     <div className="gal-content">
                        <h4 className="class-name">{item.title}</h4>
                     </div>
                  </article>
               </div>
            </div>
             ))}
           
         </div>
     
      </div>

</section>
   </>
  )
}

export default ClassPhotographs